import { buildMeta, getCompanyFromMatches } from "~/utils/meta-helpers";

import { LegalPage, LegalSection } from "../components/LegalPage";

import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = ({ matches }) => {
  const company = getCompanyFromMatches(matches);
  return buildMeta({
    title: `Política de Privacidad | ${company}`,
    description: "Qué datos tuyos usamos en AcademIA, para qué, y cuáles son tus derechos.",
  });
};

export default function PrivacyPage() {
  return (
    <LegalPage eyebrow="Legal" title="Política de Privacidad" updatedAt="24 de julio de 2026">
      <LegalSection title="1. Responsable">
        <p>
          El responsable del tratamiento de tus datos es Rodrigo González (kheprai), operador de
          AcademIA (cursosacademia.ar), Argentina. Contacto:{" "}
          <a className="font-bold text-landing-red" href="mailto:hola@cursosacademia.ar">
            hola@cursosacademia.ar
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="2. Qué datos usamos">
        <ul>
          <li>
            <b>Datos de cuenta:</b> nombre, apellido y número de teléfono (WhatsApp), que nos das al
            registrarte o pre-inscribirte.
          </li>
          <li>
            <b>Datos académicos:</b> cursos en los que estás inscripto o pre-inscripto, tu progreso,
            resultados de ejercicios y evaluaciones, y certificados emitidos.
          </li>
          <li>
            <b>Datos de uso y técnicos:</b> información básica del dispositivo y de navegación
            necesaria para que la plataforma funcione y para mejorarla.
          </li>
          <li>
            <b>Datos de pago:</b> los procesa el proveedor de pagos (por ejemplo, Mercado Pago). No
            almacenamos datos de tarjetas.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Para qué los usamos">
        <ul>
          <li>Crear tu cuenta y verificar tu identidad con códigos por WhatsApp.</li>
          <li>Darte acceso a los cursos y guardar tu progreso y certificados.</li>
          <li>
            Avisarte por WhatsApp lo que pediste que te avisemos: códigos de acceso, lanzamientos de
            cursos a los que te pre-inscribiste y novedades importantes de tu cuenta.
          </li>
          <li>Procesar compras y emitir comprobantes a través de los proveedores de pago.</li>
          <li>Mejorar los cursos y la plataforma (métricas de uso agregadas).</li>
        </ul>
        <p>
          <b>No vendemos tus datos.</b> No te vamos a llenar de spam: los mensajes de WhatsApp se
          limitan a lo que pediste.
        </p>
      </LegalSection>

      <LegalSection title="4. Con quién los compartimos">
        <p>
          Solo con los proveedores necesarios para operar la plataforma, y únicamente lo
          imprescindible: mensajería de WhatsApp (envío de códigos y avisos), procesamiento de pagos
          (Mercado Pago), e infraestructura de hosting y almacenamiento. Estos proveedores tratan
          los datos según sus propias políticas y nuestras instrucciones.
        </p>
      </LegalSection>

      <LegalSection title="5. Cookies">
        <p>
          Usamos las cookies estrictamente necesarias para que tu sesión funcione (mantenerte
          logueado de forma segura). No usamos cookies publicitarias de terceros.
        </p>
      </LegalSection>

      <LegalSection title="6. Cuánto tiempo los guardamos">
        <p>
          Mientras tengas tu cuenta activa. Si pedís la baja, eliminamos o anonimizamos tus datos
          personales dentro de un plazo razonable, salvo lo que debamos conservar por obligación
          legal (por ejemplo, comprobantes de pago) o para la verificación pública de certificados
          ya emitidos.
        </p>
      </LegalSection>

      <LegalSection title="7. Tus derechos">
        <p>
          Conforme a la Ley 25.326 de Protección de Datos Personales (Argentina), podés acceder,
          rectificar, actualizar o suprimir tus datos escribiéndonos a{" "}
          <a className="font-bold text-landing-red" href="mailto:hola@cursosacademia.ar">
            hola@cursosacademia.ar
          </a>
          . La Agencia de Acceso a la Información Pública (AAIP), como órgano de control, tiene la
          atribución de atender denuncias y reclamos sobre incumplimientos de la ley.
        </p>
      </LegalSection>

      <LegalSection title="8. Seguridad">
        <p>
          Aplicamos medidas técnicas y organizativas razonables para proteger tus datos: acceso
          cifrado (HTTPS), autenticación por código de un solo uso, y acceso restringido a la
          información. Ningún sistema es infalible; si detectamos un incidente que te afecte, te lo
          comunicaremos.
        </p>
      </LegalSection>

      <LegalSection title="9. Menores de edad">
        <p>
          La plataforma está pensada para personas mayores de 18 años. Si detectamos una cuenta de
          un menor sin consentimiento de sus responsables, la daremos de baja.
        </p>
      </LegalSection>

      <LegalSection title="10. Cambios a esta política">
        <p>
          Si cambiamos esta política de forma relevante, lo comunicaremos por la plataforma o por
          WhatsApp. La fecha de «última actualización» indica siempre la versión vigente.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
